import { Grid, styled,TextField, Typography } from '@mui/material';
import Localization from 'l18n/l18n';
import * as React from 'react';
import { Controller } from 'react-hook-form';

const StyledTextField = styled(TextField)({
    border:'0 !important',
    borderRadius:0,
    background:'#eeeeee',
    width:'100%',
    '& .MuiOutlinedInput-root' : {
      '& fieldset': {            // - The <fieldset> inside the Input-root
        border:0 // - Set the Input border
      },
     
    }
  });
function PasswordChange({ control, errors }) {

    
    return (
        <>
            <Grid item xs={ 12 } md={ 5 }>
                <Typography sx={ { mt: 2, ml: 1, fontWeight: 'bold' } }>
                    {Localization.translate.current_password}
                </Typography>

                <Controller
                    name="old_password"
                    control={ control }
                    render={ ({ field: { onChange, value } }) => (
                        <StyledTextField
                            margin="normal"
                            required
                            onChange={ onChange }
                            value={ value }
                            fullWidth
                            error={ errors[ 0 ] === 'old_password' }
                            helperText={ errors[ 0 ] === 'old_password' ? errors[ 1 ] : '' }
                            placeholder={ Localization.translate.enter_current_password }
                            type="password"
                            autoComplete="current_password"
                            
                        />
                    ) }
                />

                <Typography sx={ {mt: 2, ml: 1, fontWeight: 'bold' } }>
                    {Localization.translate.new_password}
                </Typography>

                <Controller
                    name="new_password"
                    control={ control }
                    render={ ({ field: { onChange, value } }) => (
                        <StyledTextField
                            margin="normal"
                            required 
                            onChange={ onChange }
                            value={ value }
                            fullWidth
                            placeholder={ Localization.translate.enter_new_password }
                            error={ errors[ 0 ] === 'new_password' || errors[ 0 ] === 'change_password_failed' }
                            helperText={ errors[ 0 ] === 'new_password' || errors[ 0 ] === 'change_password_failed' ? errors[ 1 ] : '' }
                            id="new-password-one"
                            type="password"
                            autoComplete="new-password-one"
                            
                        />
                    ) }
                />

            </Grid>
            <Grid  item xs={ 12 } md={ 5 } sx={ { textAlign: 'left', mt: 15 } }  >
                <Typography sx={ { mt: 2, ml: 1, fontWeight: 'bold'  } }>
                    {Localization.translate.confirm_new_password}
                </Typography>
                <Controller
                    name="repeat_new_password"
                    control={ control }
                    render={ ({ field: { onChange, value } }) => (
                        <StyledTextField
                            margin="normal"
                            onChange={ onChange }
                            value={ value }
                            error={ errors[ 0 ] === 'repeat_new_password' || errors[ 0 ] === 'new_password' }
                            helperText={ errors[ 0 ] === 'repeat_new_password' ? errors[ 1 ] : '' }
                            required
                            fullWidth
                            type="password"
                            placeholder={ Localization.translate.re_enter_new_password }
                            autoComplete="new-password-two"
                             
                        />
                    ) }
                />

            </Grid>
        </>
    );
}

export default PasswordChange;